import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({

  buttonRoot: {
    minWidth: 'unset',
    height: '34px',
    padding: '0 40px 0 40px',
    color: palette.buttonAction.color,
    background: palette.buttonAction.background,
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  buttonLabel: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    fontWeight: 800,
    textTransform: 'none',
  },
  commentForm: {
    marginBottom: 35,
  },
  commentField: {
    marginBottom: 15,
  },
  page: {
    width: '100%',
    maxWidth: 625,
  },
  wrapper: {
    background: '#FFF',
    display: 'flex',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2147483100,
  },
}));

export default useStyles;
